module.exports = __webpack_public_path__ + "static/gallery4-4e3a7171178f50372da93bc886cca1ca.png";